import type { FC } from 'react';
import { Box, Stack, Typography } from '@mui/material';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import { getArtifactKindIcon } from './helper';
import { ArtifactItem, ArtifactsProps, ArtifactsUploadAffordanceProps } from './types';

const uploadAffordanceSx = {
  alignItems: 'center',
  backgroundColor: 'background.brandSubtle',
  border: '1px dashed',
  borderColor: 'primary.main',
  borderRadius: 1,
  justifyContent: 'center',
  px: 1,
  py: 1,
};

const artifactRowSx = {
  alignItems: 'center',
  columnGap: 2,
  display: 'grid',
  gridTemplateColumns: 'auto 3fr 1.5fr 1.5fr',
  py: 0.5,
};

const DefaultUploadAffordance = ({ title = 'Upload or drag files', description }: ArtifactsUploadAffordanceProps) => {
  return (
    <Stack gap={1} alignItems="center">
      <FileUploadIcon sx={{ color: 'text.secondary' }} />
      <Typography variant="body2" color="textSecondary">
        {title}
      </Typography>
      {description && (
        <Typography variant="body2" color="textSecondary">
          {description}
        </Typography>
      )}
    </Stack>
  );
};

const ArtifactRow = ({ item }: { item: ArtifactItem }) => (
  <Box sx={artifactRowSx}>
    {getArtifactKindIcon(item.kind)}
    <Typography variant="body2" noWrap>
      {item.name}
    </Typography>
    <Typography variant="body2" color="textSecondary">
      {item.owner ?? ''}
    </Typography>
    <Typography variant="body2" color="textSecondary" justifySelf="end">
      {item.uploadedAt ?? ''}
    </Typography>
  </Box>
);

const Artifacts: FC<ArtifactsProps> = ({ items, uploadAffordanceProps }) => {
  return (
    <Stack gap={2} width="100%">
      {uploadAffordanceProps && (
        <Stack sx={uploadAffordanceSx}>
          <DefaultUploadAffordance {...uploadAffordanceProps} />
        </Stack>
      )}
      <Stack gap={0.5} width="100%">
        {items?.map(item => (
          <ArtifactRow key={item.id} item={item} />
        ))}
      </Stack>
    </Stack>
  );
};

export default Artifacts;
